import { InterpolationWithTheme } from "@emotion/core";
import { css } from "@emotion/core";


export const interventionsDailyViewStylesMobile: { [key: string]: InterpolationWithTheme<any> } = {
    summaryContainer: {
        minHeight: 260,
        marginTop: 20
    },
    cardHeaderText: {
        color: "rgba(0, 0, 0, 0.85)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "15px",
        fontWeight: 500,
    },
    table: {
        width: "100%"
    },
    divider: {
        borderTop: "2px solid rgb(182, 198, 215)",
        width: "100%",
    },
    legendContainer: {
        display: "flex",
        justifyContent: "space-between",
        background: "rgb(250, 251, 252)",
        padding: "5px 5px",
        flexWrap: "wrap"
    },
    legend: {
        display: "flex",
        color: "rgb(76, 76, 76)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: 11,
        fontWeight: 500
    },
    legendText: {
        margin: 10
    },
    iterventionNameIcon: {
        marginRight: 5
    },
    iterventionNameText: {
        marginTop: 5,
        color: "rgba(0, 0, 0, 0.87)",
        fontfamily: "BrandonTextWeb-Medium",
        fontSize: 14,
        fontWeight: 500,
        textDecoration: "underline"
    },
    tableHeader: {
        color: "rgb(128, 128, 128)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: 13,
        fontWeight: 500,
        marginBottom: 26,
        marginTop: 15,
        paddingLeft: 20
    },
    tableCols: {
        padding: "11px 0px"
    },
    activityTableCols: {
        padding: "10px 3px 10px 20px"
    },
    headerWrapper: {
        display: "flex",
        justifyContent: "space-between",
        padding: "20px 20px 0"
    },
    backIcon: {
        cursor: "pointer"
    },
    forwardIcon: {
        transform: "rotate(180deg)",
        cursor: "pointer"
    },
    weekDate: {
        color: "rgb(51, 94, 144)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: 14,
        padding: "5px 7px"
    },
    weekDatesWrapper: {
        display: "flex",
        alignItems: "center"
    },
    separator: {
        color: "rgb(51, 94, 144)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: 14,
    },
    dailyViewContainer: {
        display: "flex"
    },
    leftContainer: {
        width: "50%"
    },
    rightContainer: {
        width: "44%"
    },
    dateHeader: {
        color: "rgb(128, 128, 128)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: 13,
        fontWeight: 500
    },
    dateHeaderWrapper: {
        marginBottom: 8,
        display: "inline-flex",
        flexDirection: "column",
        textAlign: "center",
        marginTop: 15
    },
    activityList: {
        boxShadow: "5px 0px 13px -5px #aaaaaa",
        minHeight: "157px"
    },
    middleContainer: {
        width: "6%",
        top: "59px",
        position: "relative",
        height: 0
    }
}

// export const SliderItem = css`
//   div.slick-active:nth-child(3n){
//         filter: blur(2px);
//   }
//   `
// export const SliderItem = css`
//   div.slick-active:nth-child(3n){
//       .activity-data {
//         filter: blur(2px);
//       }
//   }
//   `